import { useState } from 'react';

export default function Pricing() {
  const [showSFCModal, setShowSFCModal] = useState(false);
  const [showDiamondModal, setShowDiamondModal] = useState(false);
  const [sfcFormData, setSfcFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [diamondFormData, setDiamondFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [sfcSubmitting, setSfcSubmitting] = useState(false);
  const [diamondSubmitting, setDiamondSubmitting] = useState(false);
  const [sfcSuccess, setSfcSuccess] = useState(false);
  const [diamondSuccess, setDiamondSuccess] = useState(false);

  const scrollToConsultation = () => {
    const element = document.getElementById('consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSFCSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSfcSubmitting(true);

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', sfcFormData.name);
      formBody.append('email', sfcFormData.email);
      formBody.append('phone', sfcFormData.phone);
      formBody.append('message', sfcFormData.message);

      const response = await fetch('https://readdy.ai/api/form/d661r77nq3t8fkvccgd0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });

      if (response.ok) {
        setSfcSuccess(true);
        setSfcFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => {
          setShowSFCModal(false);
          setSfcSuccess(false);
        }, 2000);
      }
    } catch (error) {
      console.error('送信エラー:', error);
    } finally {
      setSfcSubmitting(false);
    }
  };

  const handleDiamondSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setDiamondSubmitting(true);

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', diamondFormData.name);
      formBody.append('email', diamondFormData.email);
      formBody.append('phone', diamondFormData.phone);
      formBody.append('message', diamondFormData.message);

      const response = await fetch('https://readdy.ai/api/form/d661r77nq3t8fkvccgdg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });

      if (response.ok) {
        setDiamondSuccess(true);
        setDiamondFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => {
          setShowDiamondModal(false);
          setDiamondSuccess(false);
        }, 2000);
      }
    } catch (error) {
      console.error('送信エラー:', error);
    } finally {
      setDiamondSubmitting(false);
    }
  };

  return (
    <>
      <section className="py-32 px-6 bg-[#FAFAF8]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B4A] text-center mb-20">
            明確な料金体系
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-20">
            {/* SFC Plan */}
            <div className="bg-white rounded-3xl shadow-xl p-12">
              <h3 className="text-2xl font-semibold text-[#1A2B4A] text-center mb-8">SFC修行サポート</h3>
              
              <div className="text-center mb-10">
                <span className="text-3xl lg:text-5xl font-extrabold text-[#0D47A1]" style={{ fontFamily: 'DIN, sans-serif' }}>98,000円</span>
                <span className="text-sm lg:text-base text-[#5A5A5A] ml-2">(税込)</span>
              </div>

              <div className="space-y-4 mb-10">
                {['最適ルート設計', 'PP単価最適化', '5月19日以降の新ルール対応', '実行サポート'].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-xl text-[#0D47A1]"></i>
                    </div>
                    <span className="text-[15px] text-[#2C2C2C]">{item}</span>
                  </div>
                ))}
              </div>

              <a
                href="https://office4c.wixsite.com/my-site-1/booking-calendar/30分無料相談?referral=service_list_widget"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-4 bg-[#1A2B4A] text-white rounded-lg font-semibold text-base hover:bg-[#0D47A1] transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                無料相談を予約する
              </a>
              
              <a
                href="https://office-4c.jp/p/r/sK7vn3Nd"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-3 mt-3 bg-transparent border-2 border-[#1A2B4A] text-[#1A2B4A] rounded-lg font-semibold text-base hover:bg-[#F5F5F3] transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                今すぐ申し込む
              </a>
            </div>

            {/* Diamond Plan */}
            <div className="bg-white rounded-3xl shadow-xl p-12 relative">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <span className="inline-block px-4 py-1.5 bg-[#FFD700] text-[#1A2B4A] text-xs font-bold rounded-full">PREMIUM</span>
              </div>

              <h3 className="text-2xl font-semibold text-[#1A2B4A] text-center mb-8 mt-4">ANAダイヤモンドサポート</h3>
              
              <div className="text-center mb-10">
                <div className="mb-1">
                  <span className="text-3xl lg:text-5xl font-extrabold text-[#0D47A1]" style={{ fontFamily: 'DIN, sans-serif' }}>198,000円</span>
                </div>
                <span className="text-sm lg:text-base text-[#5A5A5A]">(税込)</span>
              </div>

              <div className="space-y-4 mb-10">
                {['最適ルート設計', 'PP単価最適化', '5月19日以降の新ルール対応', '実行サポート', '永久サポート(制度が続く限り)', '10万円返金保証'].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-xl text-[#0D47A1]"></i>
                    </div>
                    <span className={`text-[15px] ${index >= 4 ? 'font-semibold text-red-600' : 'text-[#2C2C2C]'}`}>{item}</span>
                  </div>
                ))}
              </div>

              <a
                href="https://office4c.wixsite.com/my-site-1/booking-calendar/30分無料相談?referral=service_list_widget"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-4 bg-[#0D47A1] text-white rounded-lg font-semibold text-base hover:bg-[#1565C0] transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                無料相談を予約する
              </a>
              
              <a
                href="https://office-4c.jp/p/r/ltn9zfVy"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-3 mt-3 bg-transparent border-2 border-[#0D47A1] text-[#0D47A1] rounded-lg font-semibold text-base hover:bg-[#E3F2FD] transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                今すぐ申し込む
              </a>
            </div>
          </div>

          {/* Guarantee */}
          <div className="max-w-4xl mx-auto bg-[#E3F2FD] rounded-3xl p-12 text-center mb-20">
            <div className="w-18 h-18 flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-7xl text-[#0D47A1]"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#1A2B4A] mb-6">安心の返金保証</h3>
            <p className="text-base leading-relaxed text-[#2C2C2C] mb-5">
              サポート開始日から1年以内に制度変更が行われ、2年目以降の修行の必要がなくなった場合には10万円を返金いたします。
            </p>
            <p className="text-[13px] text-[#5A5A5A] italic">
              ※ 詳細条件は無料相談時にご説明いたします。
            </p>
          </div>

          {/* Absolute Achievement Declaration */}
          <div className="max-w-4xl mx-auto bg-white rounded-3xl p-12 shadow-xl">
            <h3 className="text-3xl font-bold text-[#1A2B4A] text-center mb-10">絶対達成宣言</h3>
            
            <div className="space-y-6 text-[15px] leading-relaxed text-[#2C2C2C]">
              <p className="font-semibold text-center">修行は、運ではありません。</p>
              <p className="font-semibold text-center">才能でもありません。</p>
              <p className="font-semibold text-center">根性でもありません。</p>
              <p className="font-bold text-center text-xl text-[#0D47A1]">数字です。</p>
              
              <div className="py-6">
                <p className="text-center mb-3">必要プレミアムポイント。</p>
                <p className="text-center mb-3">PP単価。</p>
                <p className="text-center mb-3">搭乗回数。</p>
                <p className="text-center mb-3">残り距離。</p>
                <p className="text-center mb-3">総コスト。</p>
              </div>

              <p className="text-center">これらを正確に設計し、<br />その通りに実行すれば、</p>
              
              <p className="font-bold text-center text-xl text-[#0D47A1] py-4">
                ANAステータスは<br />必ず到達できます。
              </p>

              <p className="text-center">僕は、感覚で語りません。</p>
              <p className="text-center font-semibold">計算で語ります。</p>
              <p className="text-center font-semibold">設計で到達させます。</p>

              <div className="py-4">
                <p className="text-center">遠回りはさせません。</p>
                <p className="text-center">無駄なフライトもさせません。</p>
              </div>

              <p className="text-center font-semibold">
                あなたが設計通りに実行する限り、<br />
                ステータス獲得は「予定された結果」です。
              </p>

              <p className="text-center py-4">これは挑発ではなく、<br />ロジックの話です。</p>

              <p className="text-center font-semibold">
                再現性のある設計には、<br />
                結果が伴います。
              </p>

              <p className="text-center font-bold text-lg text-[#1A2B4A] py-4">
                僕はその設計に、<br />
                責任を持ちます。
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-200">
              <p className="text-[13px] text-[#5A5A5A] mb-4">※以下の場合を除きます。</p>
              <ul className="space-y-2 text-[13px] text-[#5A5A5A] mb-6">
                <li>・健康上の理由により搭乗が不可能となった場合</li>
                <li>・航空会社による突発的な大規模制度変更があった場合</li>
                <li>・自然災害や社会情勢により長期間運航停止となった場合</li>
                <li>・設計内容通りに実行されなかった場合</li>
              </ul>
              <p className="text-[15px] text-[#2C2C2C] font-semibold text-center">
                上記を除き、<br />
                設計通りに進めていただければ<br />
                ステータス到達は確実に可能です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SFC Modal */}
      {showSFCModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6" onClick={() => setShowSFCModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-[#1A2B4A]">SFC修行サポート申込</h3>
              <button onClick={() => setShowSFCModal(false)} className="w-8 h-8 flex items-center justify-center cursor-pointer">
                <i className="ri-close-line text-2xl text-gray-500"></i>
              </button>
            </div>
            
            {sfcSuccess ? (
              <div className="text-center py-8">
                <i className="ri-check-circle-line text-6xl text-green-500 mb-4"></i>
                <p className="text-lg font-semibold text-[#2C2C2C]">送信完了しました</p>
              </div>
            ) : (
              <form id="sfc-form" data-readdy-form onSubmit={handleSFCSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">お名前</label>
                  <input
                    type="text"
                    name="name"
                    value={sfcFormData.name}
                    onChange={(e) => setSfcFormData({...sfcFormData, name: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">メールアドレス</label>
                  <input
                    type="email"
                    name="email"
                    value={sfcFormData.email}
                    onChange={(e) => setSfcFormData({...sfcFormData, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">電話番号</label>
                  <input
                    type="tel"
                    name="phone"
                    value={sfcFormData.phone}
                    onChange={(e) => setSfcFormData({...sfcFormData, phone: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">ご質問・ご要望</label>
                  <textarea
                    name="message"
                    value={sfcFormData.message}
                    onChange={(e) => setSfcFormData({...sfcFormData, message: e.target.value})}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1] resize-none"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">{sfcFormData.message.length}/500文字</p>
                </div>
                <button
                  type="submit"
                  disabled={sfcSubmitting}
                  className="w-full py-4 bg-[#1A2B4A] text-white rounded-lg font-semibold hover:bg-[#0D47A1] transition-colors disabled:opacity-50 whitespace-nowrap cursor-pointer"
                >
                  {sfcSubmitting ? '送信中...' : '申し込む'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Diamond Modal */}
      {showDiamondModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6" onClick={() => setShowDiamondModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-[#1A2B4A]">ダイヤモンドサポート申込</h3>
              <button onClick={() => setShowDiamondModal(false)} className="w-8 h-8 flex items-center justify-center cursor-pointer">
                <i className="ri-close-line text-2xl text-gray-500"></i>
              </button>
            </div>
            
            {diamondSuccess ? (
              <div className="text-center py-8">
                <i className="ri-check-circle-line text-6xl text-green-500 mb-4"></i>
                <p className="text-lg font-semibold text-[#2C2C2C]">送信完了しました</p>
              </div>
            ) : (
              <form id="diamond-form" data-readdy-form onSubmit={handleDiamondSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">お名前</label>
                  <input
                    type="text"
                    name="name"
                    value={diamondFormData.name}
                    onChange={(e) => setDiamondFormData({...diamondFormData, name: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">メールアドレス</label>
                  <input
                    type="email"
                    name="email"
                    value={diamondFormData.email}
                    onChange={(e) => setDiamondFormData({...diamondFormData, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">電話番号</label>
                  <input
                    type="tel"
                    name="phone"
                    value={diamondFormData.phone}
                    onChange={(e) => setDiamondFormData({...diamondFormData, phone: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">ご質問・ご要望</label>
                  <textarea
                    name="message"
                    value={diamondFormData.message}
                    onChange={(e) => setDiamondFormData({...diamondFormData, message: e.target.value})}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1] resize-none"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">{diamondFormData.message.length}/500文字</p>
                </div>
                <button
                  type="submit"
                  disabled={diamondSubmitting}
                  className="w-full py-4 bg-[#0D47A1] text-white rounded-lg font-semibold hover:bg-[#1565C0] transition-colors disabled:opacity-50 whitespace-nowrap cursor-pointer"
                >
                  {diamondSubmitting ? '送信中...' : '申し込む'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
